import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { CanActivate, CanActivateChild } from '@angular/router';

@Injectable()
export class CanActivateViaAuthGuard implements CanActivate, CanActivateChild {
  constructor(private router: Router) { }

  canActivate(childRoute: import("@angular/router").ActivatedRouteSnapshot, state: import("@angular/router").RouterStateSnapshot): boolean | import("@angular/router").UrlTree | import("rxjs").Observable<boolean | import("@angular/router").UrlTree> | Promise<boolean | import("@angular/router").UrlTree> {
    return this.canActivateChild(childRoute, state);
  }

  canActivateChild(childRoute: import("@angular/router").ActivatedRouteSnapshot, state: import("@angular/router").RouterStateSnapshot): boolean | import("@angular/router").UrlTree | import("rxjs").Observable<boolean | import("@angular/router").UrlTree> | Promise<boolean | import("@angular/router").UrlTree> {
    var token = localStorage.getItem('authorization');
    if (token == null) {
      localStorage.setItem('showHeader', 'false');
      this.router.navigateByUrl('/');
      return false;
    }

    return true;
  }


}